export default "__VITE_ASSET__B1_yD_Qk__"